<template>
  <div>
    <list-page-view
      ref="dec"
      title="拒收查询"
      :needExport="true"
      :needColumn="true"
      :bodyStyle="{ 'min-height': '500px' }"
      searchHint="订单号"
      @toExport="toExport"
      @toQuery="toQuery"
      @toReset="toReset"
      @toColumn="toColumn"
      @selectColumnOK="selectColumnOK"
      :needPrint="true"
      @toPrint="toPrint"
      @STSelectedDataKeys="STSelectedDataKeys"
    >
      <a-row :gutter="48" slot="contentfilter">
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">到货单号:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input v-model="loadParams.ccode" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">供应商编码:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input placeholder="请输入供应商编码" v-model="loadParams.cvencode" :disabled="userinfo.cvencode ? true : false" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">供应商名称:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input placeholder="请输入供应商名称" v-model="loadParams.cvenname" :disabled="userinfo.cvencode ? true : false" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">批号:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input v-model="loadParams.cbatch" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">存货编码:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input v-model="loadParams.cinvcode" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">存货名称:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input v-model="loadParams.cinvname" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">到货日期:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-range-picker @change="e => handleChange(e, 'ddate')" v-model="ddate" />
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <uto-table-new ref="desc" :columns="columns" :loadParams="loadParams" :url="queryUrl" :conditions="conditions" bordered :tableId="tableId">
        <div slot="ddateR" slot-scope="flag">{{ date2string(flag) }}</div>
      </uto-table-new>
    </list-page-view>
  </div>
</template>
<script>
import { scmApi } from '@/api/scmApi'
import moment from 'moment'
export default {
  name: 'UnacceptGoods',
  data() {
    return {
      tableId: 'UnacceptGoodsTable',
      userinfo: this.$store.getters.userinfo,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultColumn: [
        {
          title: '采购订单子表标识',
          dataIndex: 'id',
          width: 150,
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'cpoid',
          width: 150,
          align: 'center'
        },
        {
          title: '到货退货子表标识',
          dataIndex: 'icorid',
          width: 150,
          align: 'center'
        },
        {
          title: '到货日期',
          dataIndex: 'ddate',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'ddateR' }
        },
        {
          title: '到货单号',
          dataIndex: 'ccode',
          width: 150,
          align: 'center'
        },
        {
          title: '结算模式',
          dataIndex: 'ccashtype',
          width: 150,
          align: 'center'
        },
        {
          title: '供应商编码',
          dataIndex: 'cvencode',
          width: 150,
          align: 'center'
        },
        {
          title: '供应商名称',
          dataIndex: 'cvenname',
          width: 150,
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'cinvcode',
          width: 150,
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'cinvname',
          width: 150,
          align: 'center'
        },
        {
          title: '物料代码',
          dataIndex: 'cinvaddcode',
          width: 150,
          align: 'center'
        },
        {
          title: '规格型号',
          dataIndex: 'cinvstd',
          width: 150,
          align: 'center'
        },
        {
          title: '拒收数量',
          dataIndex: 'iquantity',
          width: 150,
          align: 'center'
        },
        {
          title: '主计量单位',
          dataIndex: 'cinvm_unit',
          width: 150,
          align: 'center'
        },
        {
          title: '批号',
          dataIndex: 'cbatch',
          width: 150,
          align: 'center'
        },
        {
          title: '表头备注',
          dataIndex: 'cmemo',
          width: 150,
          align: 'center'
        },
        {
          title: '部门编码',
          dataIndex: 'cdepcode',
          width: 150,
          align: 'center'
        },
        {
          title: '业务员编码',
          dataIndex: 'cpersoncode',
          width: 150,
          align: 'center'
        },
        {
          title: '制单人',
          dataIndex: 'cmaker',
          width: 150,
          align: 'center'
        },
        {
          title: '采购类型',
          dataIndex: 'cptcode',
          width: 150,
          align: 'center'
        },
        {
          title: '业务类型',
          dataIndex: 'cbustype',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项1',
          dataIndex: 'cdefine1',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项2',
          dataIndex: 'cdefine2',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项3',
          dataIndex: 'cdefine3',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项4',
          dataIndex: 'cdefine4',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项5',
          dataIndex: 'cdefine5',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项6',
          dataIndex: 'cdefine6',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项7',
          dataIndex: 'cdefine7',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项8',
          dataIndex: 'cdefine8',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项9',
          dataIndex: 'cdefine9',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项10',
          dataIndex: 'cdefine10',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项11',
          dataIndex: 'cdefine11',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项12',
          dataIndex: 'cdefine12',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项13',
          dataIndex: 'cdefine13',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项14',
          dataIndex: 'cdefine14',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项15',
          dataIndex: 'cdefine15',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项16',
          dataIndex: 'cdefine16',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项22',
          dataIndex: 'cdefine22',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项23',
          dataIndex: 'cdefine23',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项24',
          dataIndex: 'cdefine24',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项25',
          dataIndex: 'cdefine25',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项26',
          dataIndex: 'cdefine26',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项27',
          dataIndex: 'cdefine27',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项28',
          dataIndex: 'cdefine28',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项29',
          dataIndex: 'cdefine29',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项30',
          dataIndex: 'cdefine30',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项31',
          dataIndex: 'cdefine31',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项32',
          dataIndex: 'cdefine32',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项33',
          dataIndex: 'cdefine33',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项34',
          dataIndex: 'cdefine34',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项35',
          dataIndex: 'cdefine35',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项36',
          dataIndex: 'cdefine36',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项37',
          dataIndex: 'cdefine37',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项1',
          dataIndex: 'cinvdefine1',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项2',
          dataIndex: 'cinvdefine2',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项3',
          dataIndex: 'cinvdefine3',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项4',
          dataIndex: 'cinvdefine4',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项5',
          dataIndex: 'cinvdefine5',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项6',
          dataIndex: 'cinvdefine6',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项7',
          dataIndex: 'cinvdefine7',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项8',
          dataIndex: 'cinvdefine8',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项9',
          dataIndex: 'cinvdefine9',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项10',
          dataIndex: 'cinvdefine10',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项11',
          dataIndex: 'cinvdefine11',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项12',
          dataIndex: 'cinvdefine12',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项13',
          dataIndex: 'cinvdefine13',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项14',
          dataIndex: 'cinvdefine14',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项15',
          dataIndex: 'cinvdefine15',
          width: 150,
          align: 'center'
        },
        {
          title: '存货自定义项16',
          dataIndex: 'cinvdefine16',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项1',
          dataIndex: 'cfree1',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项2',
          dataIndex: 'cfree2',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项3',
          dataIndex: 'cfree3',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项4',
          dataIndex: 'cfree4',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项5',
          dataIndex: 'cfree5',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项6',
          dataIndex: 'cfree6',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项7',
          dataIndex: 'cfree7',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项8',
          dataIndex: 'cfree8',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项9',
          dataIndex: 'cfree9',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项10',
          dataIndex: 'cfree10',
          width: 150,
          align: 'center'
        }
      ],
      columns: [],
      selectedRowKeys: [],
      selectedRows: [],
      loadParams: {
        ibilltype: '2'
      },
      queryUrl: scmApi.queryRejectPager,
      ddate: null,
      dstart: null,
      conditions: {
        cinvcode: 'like_anywhere',
        cinvname: 'like_anywhere',
        cvencode: 'equal',
        cvenname: 'equal',
        ccode: 'like_anywhere',
        cpoid: 'like_anywhere',
        ddate: 'range'
      }
    }
  },
  created() {
    const that = this
    that.columns = that.defaultColumn
  },
  methods: {
    selectColumnOK(data, base) {
      const that = this
      that.columns = []
      that.defaultColumn = base
      that.columns = JSON.parse(JSON.stringify(data))
    },
    toColumn() {
      this.$refs.dec.toSelectColumn(this.defaultColumn, this.tableId)
    },
    date2string(df) {
      if (df) {
        return moment(df).format('YYYY-MM-DD')
      } else {
        return undefined
      }
    },
    toQuery(searchText) {
      const _that = this
      if (searchText) {
        _that.loadParams['cpoid'] = searchText
      } else {
        _that.loadParams['cpoid'] = ''
      }
      if (_that.dstart) {
        _that.loadParams['ddate'] = _that.dstart
      } else {
        _that.loadParams['ddate'] = ''
      }
      _that.loadParams['ibilltype'] = '2'
      _that.queryUrl = scmApi.queryRejectPager + '?t=' + parseInt(Math.random() * 1000)
    },
    handleChange(e, column) {
      const _that = this
      if (column === 'ddate') {
        if (e.length > 0) {
          _that.dstart = e[0].format('YYYY-MM-DD') + ' 00:00:00' + '~' + e[1].format('YYYY-MM-DD') + ' 23:59:59'
        } else {
          _that.dstart = null
        }
      }
    },
    toReset() {
      this.loadParams = {}
      this.ddate = null
      this.dstart = null
      this.toQuery()
    },
    toPrint() {
      const eConfig = {
        eFile: '拒收查询',
        dtf: 'jscx',
        type: 'uprint'
      }
      this.$refs.desc.toPrint(eConfig)
    },
    STSelectedDataKeys(d) {
      if (d && d.length > 0) {
        const eConf = {
          eFile: '拒收查询'
        }
        eConf['type'] = '3'
        eConf['ids'] = d.join(',')
        eConf['col'] = 'icorid'
        this.$refs.desc.toExport(eConf)
      }
    },
    toExport(e) {
      const eConf = {
        eFile: '拒收查询'
      }
      if (e.key === 'all') {
        eConf['type'] = '1'
        this.$refs.desc.toExport(eConf)
      } else if (e.key === 'page') {
        eConf['type'] = '2'
        this.$refs.desc.toExport(eConf)
      } else {
        const zmColmuns = [
          {
            title: '订单号',
            dataIndex: 'cpoid',
            width: 150,
            align: 'center'
          },
          {
            title: '供应商编码',
            dataIndex: 'cvencode',
            width: 150,
            align: 'center'
          },
          {
            title: '供应商名称',
            dataIndex: 'cvenname',
            width: 150,
            align: 'center'
          },
          {
            title: '物料名称',
            dataIndex: 'cinvname',
            width: 150,
            align: 'center'
          }
        ]
        const zmDATA = this.$refs.desc.getSD()
        this.$refs.dec.toSelectData(zmColmuns, zmDATA, 'icorid')
      }
    }
  }
}
</script>
